import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueTranslate from 'vue-translate-plugin';

import './assets/style/index.css'
import "@storefront-ui/vue/styles.scss";

Vue.use(VueAxios, axios) 
Vue.config.productionTip = false
Vue.use(VueTranslate);

var app;

export function init ({ containerId, container, props }) {
  const parent = container || document.getElementById(containerId);
  console.log("search-result widget config", props.widgetConfig)
  axios.defaults.headers.common['organization-id'] = props.widgetConfig?.org || 'Prismanote2'
  app = new Vue({
    render: h => h(App, { props: props }),
  }).$mount()

  parent.appendChild(app.$el);
}

export function clean () {
  app.$destroy();
}

export function setFiltersData () {}

if(window.dmAPI){
  window.dmAPI.registerExternalWidget('searchResult', {
    init,
    clean,
    setFiltersData
  })
} else {
  const widgetConfig = localStorage.getItem('widgetConfig') ? JSON.parse(localStorage.getItem('widgetConfig')) :  {
    "org": "Prismanote2",
    "iBusinessId": "63516306683446bf3f904040",
    "iLocationId": "64993f62675135c421e4bcb4",
    "device": "desktop",
    "page": "search-result",
    "inEditor": false,
    "accountId": "c0a40c80cc18499788e799b0c5bec862",
    "siteId": "7500705f",
    "widgetId": "458eb963db1640479d021d9283322b44",
    "widgetVersion": "25",
    "elementId": "1587311105",
    "config": {
        "addToCartBtn": true,
        "showProductFilter": "always",
        "onHoverAddtoCartBtn": true
    },
    "locale": "nl"
  };
  init({
    containerId: 'app',
    props: {
      widgetConfig
    }
  })
}
